import React from 'react';
import CommonButton from '@src/new-components/Button';

const ButtonAddBlock = ({ onClick, icon, text, disabled }) => (
  <div
    style={{
      padding: '24px 24px 16px 24px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <CommonButton
      onClick={onClick}
      disabled={disabled}
      variant="contained"
      startIcon={<img src={icon} alt="icon" />}
      style={{
        textTransform: 'none',
        borderRadius: '8px',
        border: '1px solid #1e164e20',
        backgroundColor: '#ffffff',
        fontWeight: 700,
        fontSize: '14px',
        height: '42px',
        lineHeight: '20px',
        letterSpacing: '-0.4px',
        textAlign: 'center',
        color: '#1e164e',
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed!important' : 'pointer!important',
      }}
    >
      {text}
    </CommonButton>
  </div>
);

export default ButtonAddBlock;
